import React, { useEffect, useState } from 'react';
import { Modal, Typography, Row, Col, QRCode } from 'antd';
import { branding } from '../config/branding';

const { Title, Paragraph } = Typography;

const DesktopDetection = () => {
  
  const [modalVisible, setModalVisible] = useState(false);
  
  // URLs for redirection and QR code
  const freemiumURL = branding.mobileUrl;
  
  // Function to detect if user is on desktop
  const checkIfDesktop = () => {
    // Simple check - if window width is greater than 768px and not a touch device
    const isLargeScreen = window.innerWidth > 768;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Consider it a desktop if it's a large screen and not a touch device
    // Allow bypassing the desktop block for testing
    // Run this command in your console localStorage.setItem("bypassDesktopBlock", "true");
    // And then refresh the page
    const bypassDesktopBlock = localStorage.getItem('bypassDesktopBlock') === 'true';
    if (bypassDesktopBlock) return false;
    
    return isLargeScreen && !isTouchDevice;
  };
  
  useEffect(() => {
    // Check on mount and on resize
    const checkDeviceType = () => {
      const desktop = checkIfDesktop();
      setModalVisible(desktop);
    };
    
    checkDeviceType();
    
    // Add resize event listener
    window.addEventListener('resize', checkDeviceType);
    
    // Clean up
    return () => {
      window.removeEventListener('resize', checkDeviceType);
    };
  }, []);
  
  return (
    <>
      {/* Desktop modal */}
      <Modal
        open={modalVisible}
        closable={false}
        footer={[
          <></>
        ]}
        width={600}
        centered
      >
        <Row gutter={[16, 24]} align="middle" justify="center">
          <Col span={24} style={{ textAlign: 'center' }}>
            <img src={branding.logoSrc} alt={branding.logoAlt} style={{ height: 100 }} />
            <Title level={3}>Desktop Browser Detected</Title>
            <Paragraph>
              <p>It looks like you're using a desktop browser. This app is optimised for mobile devices.</p>
              <p>To continue, please visit <b>{freemiumURL}</b> on your mobile device, or scan the QR code below to access the app.</p>
            </Paragraph>
          </Col>
          
          <Col style={{ display: 'flex', justifyContent: 'center', marginTop: 16, marginBottom: 16 }}>
            <div style={{ background: '#fff', padding: 16, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
              <QRCode
                value={freemiumURL}
                size={200}
                errorLevel="L"
                color="#000000"
                bgColor="#ffffff"
                bordered={false}
                icon={branding.logoSrc}
                iconSize={40}
                style={{ margin: '0 auto' }}
              />
            </div>
          </Col>
        </Row>
      </Modal>
      
    </>
  );
};

export default DesktopDetection;
